import errorTypes from './error-types';

export function transformGeneralError(err, vm, info) {
  return new errorTypes.AppError(err, vm, info);
}
